export const useStyles = theme => ({
  buttonProgress: {
    verticalAlign: 'middle',
    marginLeft: theme.spacing(1),
  },
  submitButton: {
    marginLeft: 'auto',
    fontWeight: 'bold',
  },
  labelClass: {
    fontSize: 20,
    top: '-5px',
    fontWeight: 'bold',
  },
  memberContainer: {
    border: 'solid 1px silver',
    cursor: 'pointer',
    display: 'block',
    padding: '6px',
    marginTop: '10px',
    textAlign: 'center',
    marginRight: '20px',
    borderRadius: '8px',
    paddingRight: '20px',
    padding: '6px 16px',
    fontSize: '14px',
    minWidth: '64px',
    boxSizing: 'border-box',
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontWeight: 'bold',
    lineHeight: '1.75',
    borderRadius: '4px',
    textTransform: 'uppercase',
  },
  memberHighlightContainer: {
    border: 'solid 1px silver',
    cursor: 'pointer',
    display: 'block',
    padding: '6px',
    marginTop: '10px',
    textAlign: 'center',
    marginRight: '20px',
    borderRadius: '8px',
    paddingRight: '20px',
    padding: '6px 16px',
    fontSize: '14px',
    minWidth: '64px',
    boxSizing: 'border-box',
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontWeight: 'bold',
    lineHeight: '1.75',
    borderRadius: '4px',
    textTransform: 'uppercase',
    background: '#009F3C',
    color: 'white',
  },
  disabledContainer: {
    cursor: 'not-allowed',
    border: 'solid 1px silver',
    display: 'block',
    padding: '6px',
    marginTop: '10px',
    textAlign: 'center',
    marginRight: '20px',
    borderRadius: '8px',
    paddingRight: '20px',
    padding: '6px 16px',
    fontSize: '14px',
    minWidth: '64px',
    boxSizing: 'border-box',
    fontWeight: 'bold',
    lineHeight: '1.75',
    borderRadius: '4px',
    textTransform: 'uppercase',
    background: 'lightgray',
    color: 'gray',
  },
});
